import { createStyles } from '@material-ui/core/styles';

export default createStyles({
  mainDiv: {
    padding: '10px'
  },
  lotLineDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#DDDDDD',
    padding: '10px'
  },
  button: {
    boxShadow: 'none',
    padding: '10px',
  },
  lotLineDataGrid: {
    width: '720px',
    height: '350px'
  },
  binLotLineDataGrid: {
    width: '920px',
    height: '350px'
  },
  disabledBtn: {
    backgroundColor: '#DDDDDD !important',
  },
  bottomRowDiv: {
  },
  bottomRow: {
    display: 'flex',
    flexFlow: 'row',
    height: '36px',
    justifyContent: 'space-between'
  },
  headingCell: {
    backgroundColor: '#dddddd',
    border: '1px solid #fff',
    color: '#000000',
    fontSize: '12px',
    fontWeight: 'bold',
    width: '75px',
    padding: '10px !important',
  },
  dataCell: {
    fontSize: '12px',
    padding: '10px !important',
    backgroundColor: '#cccccc',
    color: '#000000',
    textAlign: 'right',
    border: '1px solid #fff !important',
    width: '100px',
  },
  emphasizedCell: {
    fontSize: '13px',
    padding: '10px !important',
    backgroundColor: '#999999',
    color: '#000000',
    textAlign: 'right',
    border: '1px solid #fff !important',
    width: '100px',
  },
  cellSpacing: {
    marginRight: '31.5px'
  },
  binLotCellSpacing: {
    marginRight: '130px'
  },
  inlineFields: {
    display: 'flex',

  },
  inlineFieldsSpacing: {
    paddingLeft: '16px'
  },
  requiredEnteredBottomRow: {
    display: 'flex',
    flexFlow: 'row',
    height: '36px',
    justifyContent: 'space-between',
  },
  requiredEnteredHeadingCell: {
    backgroundColor: '#dddddd',
    border: '1px solid #fff',
    color: '#000000',
    fontSize: '12px',
    fontWeight: 'bold',
    width: '75px',
    padding: '10px !important',
    flex: 1
  },
  requiredEnteredDataCell: {
    fontSize: '12px',
    padding: '10px !important',
    backgroundColor: '#cccccc',
    color: '#000000',
    textAlign: 'right',
    border: '1px solid #fff !important',
    width: '100px',
    flex: 1
  },
  requiredEnteredEmphasizedCell: {
    fontSize: '13px',
    padding: '10px !important',
    backgroundColor: '#999999',
    color: '#000000',
    textAlign: 'right',
    border: '1px solid #fff !important',
    width: '100px',
    flex: 1
  },
});
